const url_version_1 = 'v1/'; // version 1

export const endpointsApi = (url_api: string) => ({
  // Formation
  getModules: `${url_api}${url_version_1}modules`, // Get all modules
  getScore: `${url_api}${url_version_1}modules/{uuid}/score`, // Get scores
  startModule: `${url_api}${url_version_1}modules/{uuid}/start`, // Start module
  finishModule: `${url_api}${url_version_1}modules/{uuid}/finish`, // Finish module
  getLastRefQuestion: `${url_api}${url_version_1}modules/{uuid}/last-ref-question`, // Get last question ref

  // Question
  getQuestionByRef: `${url_api}${url_version_1}questions/reference/{reference}`, // Get question by ref
  addAnswer: `${url_api}${url_version_1}questions/{id}/answer`, // Add answer

  // User
  login: `${url_api}${url_version_1}users/login`, // Login
  addUser: `${url_api}${url_version_1}users/sign-up`, // Create user
  editUser: `${url_api}${url_version_1}users`, // Edit user
  getCurrentUser: `${url_api}${url_version_1}users/current`, // Get current user
  forgotPassword: `${url_api}${url_version_1}users/password/forgot/send-email`, // Forgot password
  resetPassword: `${url_api}${url_version_1}users/password/forgot/reset`, // Reset password,
  trackingConsent: `${url_api}${url_version_1}users/tracking`, // Set tracking consent

  // Stats
  getStats: `${url_api}${url_version_1}stats/summary`, // Get stats
  getStatsUser: `${url_api}${url_version_1}stats/user-summary`, // Get user stats v1/stats/user-summary
});
